import {
  Box,
  RangeSlider,
  RangeSliderFilledTrack,
  RangeSliderThumb,
  RangeSliderTrack,
  Stack,
  Text,
} from '@chakra-ui/react'
import React from 'react'

import { FormContext, type FormInputType } from '../types'

function formatHour(hour: number): string {
  return hour === 24
    ? '11:59 PM'
    : `${hour % 12 === 0 ? 12 : hour % 12} ${hour >= 12 ? 'PM' : 'AM'}`
}

const FormInputTimeRange: React.FC<{
  input: FormInputType & { type: 'time-range' }
}> = ({ input }) => {
  const { name: inputName, initialValue, onChange: inputOnChange } = input

  const { onChange } = React.useContext(FormContext)

  const [value, setValue] = React.useState(initialValue ?? [0, 24])

  const handleChange = React.useCallback(
    (val: number[]) => {
      onChange(inputName, val)
      inputOnChange?.(val)
      setValue(val)
    },
    [inputName, onChange, inputOnChange]
  )

  return (
    <Box>
      <Stack
        width="100%"
        spacing="4px"
        align="center"
        direction="row"
        justify="space-between"
        mb="2px"
      >
        <Text fontWeight="bold" color="fg" fontSize="14px">
          {formatHour(value[0])}
        </Text>
        <Text fontWeight="bold" color="fg" fontSize="14px">
          {formatHour(value[1])}
        </Text>
      </Stack>
      <Box px="16px">
        <RangeSlider
          min={0}
          max={24}
          step={1}
          defaultValue={initialValue?.map(Number)}
          value={value}
          onChange={val => {
            handleChange(val)
          }}
          minStepsBetweenThumbs={1}
        >
          <RangeSliderTrack height="8px" bg="primary.subtle" width="12px">
            <RangeSliderFilledTrack height="8px" bg="primary.solid" />
          </RangeSliderTrack>
          <RangeSliderThumb
            index={0}
            boxSize="24px"
            border="2px solid"
            borderColor="border.emphasized"
          />
          <RangeSliderThumb
            index={1}
            boxSize="24px"
            border="2px solid"
            borderColor="border.emphasized"
          />
        </RangeSlider>
      </Box>
    </Box>
  )
}

export default FormInputTimeRange
